import { ReceiptSystemProviderEnum } from "./types";

export function isMultipleLegalEntitiesEnabled(
	configuration: Record<string, any> | null | undefined,
): boolean {
	return configuration?.multipleLegalEntities === true;
}

export function isFleetIdnoRequired(params: {
	providers: Array<{
		active?: boolean;
		provider?: string;
		configuration?: Record<string, any> | null;
		taxiServiceIds?: number[];
	}>;
	taxiServiceIds?: number[];
}): boolean {
	const multiProviders = params.providers.filter(
		(provider) =>
			!!provider.active &&
			provider.provider === ReceiptSystemProviderEnum.FISCAL_PARTNER &&
			isMultipleLegalEntitiesEnabled(provider.configuration),
	);

	if (!multiProviders.length) return false;

	const fleetTaxiServiceIds = params.taxiServiceIds ?? [];
	if (!fleetTaxiServiceIds.length) return true;

	return multiProviders.some((provider) =>
		(provider.taxiServiceIds ?? []).some((id) =>
			fleetTaxiServiceIds.includes(id),
		),
	);
}

/** Checkbox: несколько касс (ключ и пин лежат в кассах, а не в провайдере). */
export function isMultipleRegistersEnabled(
	provider: string | null | undefined,
	configuration: Record<string, any> | null | undefined,
): boolean {
	return (
		provider === ReceiptSystemProviderEnum.CHECKBOX &&
		configuration?.multipleRegisters === true
	);
}
